import { Component, OnInit, Inject, SystemJsNgModuleLoader } from '@angular/core';
import { SessionService } from './session.service';
import { ActivatedRoute, Router, NavigationCancel } from '@angular/router';
import { DOCUMENT } from "@angular/common";
import { IMyDpOptions } from 'mydatepicker';

import { RequestService } from "./request.service";
import { WelcomePageService } from './services/welcome-Page.service';
import { SurveyDeployerWCPageResponseJSON } from "./common/JSON/wcPage/Survey-Deployer-WC-Page-Response-JSON";
import { SurveyDeployerWCPageRequestJSON } from "./common/JSON/RequestTOJSON/Survey-Deployer-WC-Page-Request.JSON";
import { PageHeaderResponseJSON } from "./common/JSON/surveyHeader/Page-Header-Response-JSON";
import { WCPageDetailsResponseJSON } from "./common/JSON/wcPage/WC-Page-Details-Response-JSON";
import { PageFooterResponseJSON } from "./common/JSON/surveyFooter/Page-Footer-Response-JSON";
import { SurveyDeployerConfigResponseJSON } from "./common/JSON/surveyConfig/Survey-Deployer-Config-Response-JSON";
import { SurveyDeployerWCPageValidationJSON } from "./common/JSON/wcPageValidation/Survey-Deployer-WC-Page-Validation.JSON";
import { QuestionDetailsHeaderRequestJSON } from "./common/JSON/RequestTOJSON/Question-Details-Header-Request.JSON";
import { SurveyDeployerQuestionPageRequestJSON } from "./common/JSON/RequestTOJSON/Survey-Deployer-Question-Page-Request.JSON";
import { DateValue } from "./common/JSON/util/Date-Value";
import { DateComponent } from "./common/JSON/util/Date-Component";
import '../assets/js/base64.js';

declare var Base64: any;

@Component({
  selector: 'altSurvey-root',
  templateUrl: './app.component.html',
  providers: [WelcomePageService]
})

export class AppComponent implements OnInit {
  //Sohum: sohum, Production : prod, Staging: stag, UAT:uat
  private environment:string;
  private fullURL: string;
  private baseURI: string;
  private encodedSurveyCode: string[];
  private decodedSurveyCode: String;
  private urlSplitPart1: String[] = [];
  private urlSplitPart2: String[] = [];
  private surveyURL: String;

  private decodeSurveyCodeSplit: string[];
  private contextEntityID;
  private ContextInstanceId;
  private TenantID;
  private OrgID;
  private Editable;
  private userID;
  private roleID;
  private sysSurveyRunID;
  private isHistorical;
  private contextEntityID_: string[];
  private ContextInstanceId_: string[];
  private TenantID_: string[];
  private OrgID_: string[];
  private Editable_: string[];
  private userID_: string[];
  private roleID_: string[];
  private isHistorical_: string[];

  
  private json: any;
  public error = false;
  public expire = false;
  public thanks = false;
  public loading = false;
  public goToDetails = false;
  public goToQuestions = false;
  private header;
  private footer;
  private details;
  private apiUrlPreffix:string = 'altservices';
  private apiUrlSuffix: string = '/SurveyServices';
  private protocol: string = "https://";
  private finalUrl : string;
  private dateFormat: IMyDpOptions = {
    // other options...
    dateFormat: 'dd.mm.yyyy',
  };

  private questionDetailsHeaderRequestJSON: QuestionDetailsHeaderRequestJSON;
  private surveyDeployerQuestionPageRequestJSON: SurveyDeployerQuestionPageRequestJSON;

  pageHeaderResponseJSON: PageHeaderResponseJSON;
  wCPageDetailsResponseJSON: WCPageDetailsResponseJSON;
  pageFooterResponseJSON: PageFooterResponseJSON;

  // Need to fire Rest Service and fetch All WelcomePage Data here and send to component HTMl as variable.
  title = 'ALt Survey Deployer';
  responseData: SurveyDeployerWCPageResponseJSON;
  surveyDeployerWCPageRequestJSON: SurveyDeployerWCPageRequestJSON;

  constructor(
    private welcomePageService: WelcomePageService,
    private router: Router,
    private requestService: RequestService,
    private sessionService:SessionService,
    // private requestSrvc: RequestService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.fullURL = this.document.location.href;
    this.baseURI = this.document.baseURI;

    if (this.fullURL.indexOf("?surveyCode=") > 0) {
      this.urlSplitPart1 = this.fullURL.split("?");
      this.urlSplitPart2 = this.urlSplitPart1[0].split("://");
      this.encodedSurveyCode = this.urlSplitPart1[1].split("surveyCode=");
      this.findEnvironment(this.urlSplitPart2[1]);
      this.surveyURL = this.urlSplitPart2[1]
     //this.surveyURL = this.urlSplitPart2[1].slice(15); ////Temp for Testing/Development
    } else {
      var a = this.fullURL.split("//");
      this.urlSplitPart2.push(a[1]);
      this.findEnvironment(this.urlSplitPart2[0]);
     // var b=this.urlSplitPart2[0].split('4200/');
      this.surveyURL = this.urlSplitPart2[0] //Original
      //this.surveyURL = b[1]; //Testing
    }
  }

  findEnvironment(surveyURL:String){
    if(surveyURL.includes("sohum") || surveyURL.includes("SOHUM") || surveyURL.includes("Sohum")){
      this.finalUrl="https://sohum-altservices.peoplestrong.com/SurveyServices";
    }
    // else if(surveyURL.includes("local") || surveyURL.includes("LOCAL") || surveyURL.includes("Local")){
    //   this.environment="local";
    //   this.sessionService.envString="local";
    // }else if(surveyURL.includes("staging-survey") || surveyURL.includes("STAGIN-SURVEY") || surveyURL.includes("Staging-Survey")){
    //   this.environment="staging";
    //   this.sessionService.envString="staging";
    // }else if(surveyURL.includes("uat-altsurvey") || surveyURL.includes("UAT-ALTSURVEY") || surveyURL.includes("Uat-Altsurvey")){
    //   this.environment="uat";
    //   this.sessionService.envString="uat";
    // }else if(surveyURL.includes("survey.peoplestrong") || surveyURL.includes("SURVEY.PEOPLESTRONG")  || surveyURL.includes("Survey.Peoplestrong")){
    //   this.environment="prod";
    //   this.sessionService.envString="prod";
    // }
    else if(surveyURL.includes("uat-altsurvey.peoplestrong") || surveyURL.includes("UAT-ALTSURVEY.PEOPLESTRONG")  || surveyURL.includes("Uat-AltSurvey.Peoplestrong")){
      this.finalUrl="https://uat-altsurvey-altservices.peoplestrong.com/SurveyServices";
    }else if(surveyURL.includes("staging-survey.peoplestrong") || surveyURL.includes("STAGING-SURVEY.PEOPLESTRONG")  || surveyURL.includes("Staging-Survey.Peoplestrong")){
      this.finalUrl="https://staging-altservices.peoplestrong.com/SurveyServices";
    }else if(surveyURL.includes("survey.peoplestrong") || surveyURL.includes("SURVEY.PEOPLESTRONG")  || surveyURL.includes("Survey.Peoplestrong")){
      this.finalUrl="https://altservices.peoplestrong.com/SurveyServices";
    }else if(surveyURL.includes("survey-ae.peoplestrong") || surveyURL.includes("SURVEY-AE.PEOPLESTRONG")  || surveyURL.includes("Survey-ae.Peoplestrong")){
      this.finalUrl="https://altservices-ae.peoplestrong.com/SurveyServices";
    }else{
    this.finalUrl= "https://"+surveyURL.substring(0,surveyURL.indexOf(".")) +"-"+this.apiUrlPreffix+surveyURL.substring(surveyURL.indexOf("."),surveyURL.indexOf(".com")+(".com").length)  + this.apiUrlSuffix ;
    }
    this.sessionService.setUrls(this.finalUrl);
  }

  convertDateStringToDateObject(wCPageDetailsResponseJSON: WCPageDetailsResponseJSON) {

    wCPageDetailsResponseJSON.hHTMLDisplayComponentJSONList.forEach(htmlDisplayComp => {
      htmlDisplayComp.inputHTMLComponentJSONList.forEach(element => {
        if (element.type == 7) {
          if (element.value != null) {
            var arr = element.value.split("/");
            if(element.dateValue==null)
              element.dateValue=new DateValue;
            if(element.dateValue.date==null || element.dateValue.date==undefined)
              element.dateValue.date = new DateComponent;
            element.dateValue.date.day = arr[1];
            element.dateValue.date.month = arr[0];
            element.dateValue.date.year = arr[2];
          }
        }
      });
    });
  }

  //fetch the detail of the Welcome Page
  getWelcomePageDetails(surveyDeployerWCPageRequestJSON: SurveyDeployerWCPageRequestJSON) {
    this.responseData = new SurveyDeployerWCPageResponseJSON;
    this.pageHeaderResponseJSON = new PageHeaderResponseJSON;
    this.wCPageDetailsResponseJSON = new WCPageDetailsResponseJSON;
    this.pageFooterResponseJSON = new PageFooterResponseJSON;
    this.loading = true;

    this.welcomePageService.getWelcomePageDetails(this.surveyDeployerWCPageRequestJSON).subscribe(out => {
      this.loading = false;
      if (out.responseData[0].surveyDeployerWCPageValidationJSON.pageRedirectTo == "success" ||
      out.responseData[0].surveyDeployerWCPageValidationJSON.pageRedirectTo == "SuccessQP"||
      out.responseData[0].surveyDeployerWCPageValidationJSON.pageRedirectTo == "SavedQP") {
       
        this.pageHeaderResponseJSON = out.responseData[0].wCPageHeaderResponseJSON;
        this.wCPageDetailsResponseJSON = out.responseData[0].wCPageDetailsResponseJSON;
        this.convertDateStringToDateObject(this.wCPageDetailsResponseJSON);
        this.pageFooterResponseJSON = out.responseData[0].wCPageFooterResponseJSON;
        this.welcomePageService.setWelcomePageDetailData(this.wCPageDetailsResponseJSON);

        this.goToDetails = true;

        //fill Next Page info
        this.questionDetailsHeaderRequestJSON = new QuestionDetailsHeaderRequestJSON;
        this.questionDetailsHeaderRequestJSON.surveyID = out.responseData[0].surveyID;
        this.surveyDeployerQuestionPageRequestJSON = new SurveyDeployerQuestionPageRequestJSON;
        this.surveyDeployerQuestionPageRequestJSON.surveyID = out.responseData[0].surveyID;
        this.surveyDeployerQuestionPageRequestJSON.questionPageHeaderResponseJSON = out.responseData[0].wCPageHeaderResponseJSON;
        this.surveyDeployerQuestionPageRequestJSON.questionPageFooterResponseJSON = out.responseData[0].wCPageFooterResponseJSON;
        this.surveyDeployerQuestionPageRequestJSON.questionDetailsHeaderRequestJSON = this.questionDetailsHeaderRequestJSON;
        this.surveyDeployerQuestionPageRequestJSON.contextEntityId = this.requestService.getSurveyDeployerWCPageRequestJSON().contextEntityId;
        this.surveyDeployerQuestionPageRequestJSON.contextInstanceId = this.requestService.getSurveyDeployerWCPageRequestJSON().contextInstanceId;
        this.surveyDeployerQuestionPageRequestJSON.tenantID = this.requestService.getSurveyDeployerWCPageRequestJSON().tenantId;
        this.surveyDeployerQuestionPageRequestJSON.userID = this.requestService.getSurveyDeployerWCPageRequestJSON().userID;
        this.surveyDeployerQuestionPageRequestJSON.roleID = this.requestService.getSurveyDeployerWCPageRequestJSON().roleID;
        this.surveyDeployerQuestionPageRequestJSON.sysSurveyRunID = this.requestService.getSurveyDeployerWCPageRequestJSON().sysSurveyRunID;
        this.surveyDeployerQuestionPageRequestJSON.isHistorical = this.requestService.getSurveyDeployerWCPageRequestJSON().isHistorical;
        this.requestService.setConfig(out.responseData[0].surveyDeployerConfigResponseJSON);

        this.wCPageDetailsResponseJSON.alreadySubmitted = out.responseData[0].surveyDeployerWCPageValidationJSON.pageRedirectTo == "SuccessQP";
        this.wCPageDetailsResponseJSON.alreadySaved = out.responseData[0].surveyDeployerWCPageValidationJSON.pageRedirectTo == "SavedQP";
      } else if (out.responseData[0].surveyDeployerWCPageValidationJSON.pageRedirectTo == "Page404") {
        this.error = true;
        this.expire = false;
        this.thanks = false;
        this.loading = false;
      } else if (out.responseData[0].surveyDeployerWCPageValidationJSON.pageRedirectTo == "ExpirePage") {
        this.responseData = out.responseData;
        this.pageHeaderResponseJSON = out.responseData[0].wCPageHeaderResponseJSON;
        this.pageFooterResponseJSON = out.responseData[0].wCPageFooterResponseJSON;
        this.error = false;
        this.expire = true;
        this.thanks = false;
        this.loading = false;
        

      }else if (out.responseData[0].surveyDeployerWCPageValidationJSON.pageRedirectTo == "SurveyComplete") {
        this.responseData = out.responseData;
        this.pageHeaderResponseJSON = out.responseData[0].wCPageHeaderResponseJSON;
        this.pageFooterResponseJSON = out.responseData[0].wCPageFooterResponseJSON;
        this.error = false;
        this.expire = false;
        this.thanks = true;
        this.loading = false;
    }
    }, err => {
      this.error = true;
      this.expire = false;
      this.thanks = false;
      this.loading = false;
    });
  }

  //Crete JSON from Decoded Data
  setDecodedJSONObj(decodedSurveyCode: String) {
    // //ContextEntityId_225?ContextInstanceId_39399?TenantId_66?OrganizationId_111?Editable_true?USERID_279009

    //ContextEntityId_225_ContextInstanceId_39399_TenantId_66_OrganizationId_111_Editable_true_USERID_279009
    this.decodeSurveyCodeSplit = decodedSurveyCode.split("_");
    this.contextEntityID_ = this.decodeSurveyCodeSplit[0].split("_");
    this.ContextInstanceId_ = this.decodeSurveyCodeSplit[2].split("_");
    this.TenantID_ = this.decodeSurveyCodeSplit[4].split("_");
    this.OrgID_ = this.decodeSurveyCodeSplit[6].split("_");
    this.Editable_ = this.decodeSurveyCodeSplit[8].split("_");
    this.userID_ = this.decodeSurveyCodeSplit[10].split("_");
    this.contextEntityID = this.decodeSurveyCodeSplit[1];
    this.ContextInstanceId = this.decodeSurveyCodeSplit[3];
    
    this.OrgID = this.decodeSurveyCodeSplit[7];
    this.TenantID = this.decodeSurveyCodeSplit[5];
    this.Editable = this.decodeSurveyCodeSplit[9];
    this.userID = this.decodeSurveyCodeSplit[11];
    if(this.decodeSurveyCodeSplit.indexOf('isHistorical') != -1){
      let index_isHistorical = this.decodeSurveyCodeSplit.indexOf('isHistorical');
      this.isHistorical_ = this.decodeSurveyCodeSplit[index_isHistorical].split("_");
      this.isHistorical = this.decodeSurveyCodeSplit[index_isHistorical + 1];
    }
    if(this.decodeSurveyCodeSplit.indexOf('RoleID') != -1){
      let index_RoleID = this.decodeSurveyCodeSplit.indexOf('RoleID');
      this.roleID_ = this.decodeSurveyCodeSplit[index_RoleID].split("_");
      this.roleID = this.decodeSurveyCodeSplit[index_RoleID + 1];
    }
    if (this.decodeSurveyCodeSplit.indexOf('SysSurveyRunID') != -1) {
      let index = this.decodeSurveyCodeSplit.indexOf('SysSurveyRunID');
      this.sysSurveyRunID = this.decodeSurveyCodeSplit[index + 1];
    }

    //Create JSON
    this.surveyDeployerWCPageRequestJSON = new SurveyDeployerWCPageRequestJSON();
    this.surveyDeployerWCPageRequestJSON.link = this.surveyURL;
    this.surveyDeployerWCPageRequestJSON.userID = this.userID;
    this.surveyDeployerWCPageRequestJSON.contextEntityId = this.contextEntityID;
    this.surveyDeployerWCPageRequestJSON.contextInstanceId = this.ContextInstanceId;
    this.surveyDeployerWCPageRequestJSON.tenantId = this.TenantID;
    this.surveyDeployerWCPageRequestJSON.organizationId = this.OrgID;
    this.surveyDeployerWCPageRequestJSON.editable_true = this.Editable;
    this.surveyDeployerWCPageRequestJSON.isHistorical = this.isHistorical;
    this.surveyDeployerWCPageRequestJSON.roleID =  this.roleID;
    this.surveyDeployerWCPageRequestJSON.sysSurveyRunID =  this.sysSurveyRunID;


    this.requestService.setSurveyDeployerWCPageRequestJSON(this.surveyDeployerWCPageRequestJSON);
  }


  //Invoke on start up of the Appication 
  ngOnInit(): void {
    localStorage.setItem('showPrintButton','false');
    if (this.encodedSurveyCode) {
      var decodedSurveyCodeWithoutSpecialChar=this.encodedSurveyCode[1].replace(/[^A-Za-z0-9\+\/\=]/g, "");
      this.decodedSurveyCode = Base64.decode(decodedSurveyCodeWithoutSpecialChar);
      // this.decodedSurveyCode = atob(this.encodedSurveyCode[1]);
      //Fill Request JSON Obj 
      this.setDecodedJSONObj(this.decodedSurveyCode.trim());
    } else {
      this.surveyDeployerWCPageRequestJSON = new SurveyDeployerWCPageRequestJSON;
      this.surveyDeployerWCPageRequestJSON.link = this.urlSplitPart2[0];
      // var b=this.urlSplitPart2[0].split('4200/');
      this.surveyURL = this.urlSplitPart2[0] //Original
      //this.surveyDeployerWCPageRequestJSON.link = b[1]; //Testing
    }
    this.getWelcomePageDetails(this.surveyDeployerWCPageRequestJSON);
  }

  changePage() {
    //go to questions page
    this.goToQuestions = true;
    this.goToDetails = false;
  }

  get showPrintButton(): any {
    if (localStorage.getItem('showPrintButton') == 'true') {
      return true;
    }
    else {
      return false;
    }
  }
  printCurrentPage() 
  {
    window.print()
  }
}
